import { Icon } from '@/components/common';
import Icons from '@/const/icons';
import useChatBox from '@/hooks/useChatBox';
import * as React from 'react';
import { ChatBoxContainer } from './ChatBoxContainer';
import { useChatMessages, useShowChat } from '@/hooks';
import clsx from 'clsx';
import { useRouter } from 'next/router';

export const ChatButton: React.FC = () => {
	const { pathname } = useRouter();
	const { ChatBox, show, hide } = useChatBox();
	const { showChatBox, closeShowChatBox, openShowChatBox } = useShowChat();
	const { chatMessages, isConversationOver, addHelloMessage, resetContext } =
		useChatMessages();

	React.useEffect(() => {
		if (showChatBox) show();
	}, [showChatBox]);

	return (
		<div
			className={clsx('relative hidden lg:block', {
				hidden: pathname.includes('settings'),
			})}
		>
			<div className="fixed bottom-10 right-8 z-[30]">
				<button
					className="w-16 p-5 h-16 bg-primary rounded-full flex items-center justify-center"
					style={{ boxShadow: '0px 2px 5px 0px #0000003D' }}
					onClick={() => {
						if (chatMessages.length === 0) {
							addHelloMessage();
						}
						openShowChatBox();
						show();
					}}
				>
					<Icon
						src={Icons.hat}
						className="!w-6 !h-6 bot"
						width={24}
						height={24}
					/>
				</button>
				<ChatBox className="!w-[45vh] xl:!w-[26rem] !h-[35rem] 2xl:!h-[40rem]">
					<ChatBoxContainer
						toggle={() => {
							hide();
							closeShowChatBox();
						}}
						close={() => {
							resetContext();
							hide();
							closeShowChatBox();
						}}
						from="chat"
						className={isConversationOver ? '' : 'max-h-[80%]'}
					/>
				</ChatBox>
			</div>
		</div>
	);
};
